import { service } from '@ember/service';
import BaseEditionForm from 'parog-web/components/mici/base-edition-form';
import RchSurveyFilledJournalEvent from 'parog-web/models/rch-survey-filled-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';
import MiciBaseEditionFormEditionForm from './base-edition-form/edition-form/index';

export default class MiciRchSurveyEditionForm extends MiciBaseEditionFormEditionForm {
  static override fullComponentId = 'mici/rch-survey-edition-form';
  static override journalEventClass = RchSurveyFilledJournalEvent;

  @service declare session: SemeiaSessionService;

  override get currentSections(): Array<string> {
    return [
      'averageStoolsNumber',
      ...this.#bloodInStoolSections,
      ...this.#analIncontinenceSections,
      ...this.#immedialStoolSections,
      'wellBeing',
      ...this.#articularPainSections,
      'mouthUlcers',
      'skinSymptoms',
      ...this.#eyeSymptomsSections,
      ...this.#feverSections,
      'weight'
    ];
  }

  override get forcDisplayName(): string {
    return this.session.medic ? 'Questionnaire RCH' : 'Symptômes';
  }

  get #analIncontinenceSections(): string[] {
    if (this.changeset.get('analIncontinence')) {
      return ['analIncontinence', 'analIncontinenceFrequency'];
    }
    return ['analIncontinence'];
  }

  get #articularPainSections(): string[] {
    if (this.changeset.get('articularPain')) {
      return ['articularPain', 'articularPainSeverity'];
    }
    return ['articularPain'];
  }

  get #bloodInStoolSections(): string[] {
    if (this.changeset.get('bloodInStool')) {
      return ['bloodInStool', 'bloodInStoolFrequency'];
    }
    return ['bloodInStool'];
  }

  get #eyeSymptomsSections(): string[] {
    if (this.changeset.get('eyeSymptoms')) {
      return [
        'eyeSymptoms',
        'eyeSymptomsRedEye',
        'eyeSymptomsPainful',
        'eyeSymptomsSight'
      ];
    }
    return ['eyeSymptoms'];
  }

  get #feverSections(): string[] {
    if (this.changeset.get('fever')) {
      return ['fever', 'feverLevel'];
    }
    return ['fever'];
  }

  get #immedialStoolSections(): string[] {
    if (this.changeset.get('immediateStool')) {
      return ['immediateStool', 'immediateStoolUrgency'];
    }
    return ['immediateStool'];
  }

  override afterCompleted = () => {
    this.analytics.trackPatientMeasurement('rch-survey');
    if (this.args.afterCompleted) this.args.afterCompleted();
  };

  <template>
    <BaseEditionForm
      @changeset={{this.changeset}}
      @save={{this.onSave}}
      @currentSections={{this.currentSections}}
      @patient={{this.patient}}
    >
      <:title>
        Au cours des 7 derniers jours
      </:title>
    </BaseEditionForm>
  </template>
}
